import React, { useState, useEffect } from 'react';
import { fetchReviews } from '../api';
import ReviewCard from '../components/ReviewCard';
import Loader from '../components/Loader';

const STATUS_FILTERS = [
  { id: 'all',      label: '🏆 All' },
  { id: 'offer',    label: '✅ Received' },
  { id: 'ghosted',  label: '👻 Ghosted' },
  { id: 'rejected', label: '❌ Rejected' },
  { id: 'ongoing',  label: '⏳ In Progress' },
];

export default function MostLikedPage({ setView, setActiveFilter }) {
  const [kahanis, setKahanis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    fetchReviews({ limit: 500 })
      .then(data => {
        const sorted = (data.reviews || [])
          .filter(r => (r.upvotes || 0) > 0)
          .sort((a, b) => (b.upvotes || 0) - (a.upvotes || 0));
        setKahanis(sorted);
      })
      .catch(err => {
        console.error('Failed to load most liked kahanis:', err);
        setKahanis([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const filtered = statusFilter === 'all' ? kahanis : kahanis.filter(r => r.status === statusFilter);

  return (
    <div style={{ animation: 'fadeUp 0.4s ease-out', paddingTop: 8 }}>

      {/* Header + filters — sticky */}
      <div style={{ position: 'sticky', top: 0, zIndex: 10, background: 'var(--bg)', padding: '2px 0 6px', marginBottom: 4 }}>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 16, fontWeight: 900, margin: '0 0 2px', color: 'var(--text)' }}>
          Most Liked Kahani's
        </h1>
        <p style={{ fontSize: 11, color: 'var(--text3)', margin: '0 0 8px' }}>
          {loading ? 'Loading…' : `${filtered.length} kahanis ranked by community upvotes`}
        </p>

      {/* Filter pills */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {STATUS_FILTERS.map(f => (
          <button
            key={f.id}
            onClick={() => setStatusFilter(f.id)}
            style={{
              padding: '5px 14px', borderRadius: 100, fontSize: 11, fontWeight: 700,
              border: `1px solid ${statusFilter === f.id ? 'var(--blue)' : 'var(--border2)'}`,
              background: statusFilter === f.id ? 'var(--blue)' : 'var(--surface)',
              color: statusFilter === f.id ? '#fff' : 'var(--text2)',
              cursor: 'pointer', transition: 'all 0.15s', whiteSpace: 'nowrap',
              fontFamily: 'var(--sans)',
            }}
          >
            {f.label}
          </button>
        ))}
      </div>
      </div>

      {/* List */}
      {loading ? (
        <Loader inline message="Loading most liked kahanis…" />
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--text3)', fontSize: 14 }}>
          {statusFilter === 'all' ? 'No upvoted kahanis yet. Be the first to upvote! 🔥' : `No ${statusFilter} kahanis in the top ranked list.`}
        </div>
      ) : (
        filtered.map((r, i) => (
          <ReviewCard key={r.id || r._id || i} review={r} delay={i * 0.03} />
        ))
      )}
    </div>
  );
}
